<h1 mat-dialog-title>{{ entsorger ? entsorger.name : "Entsorger anlegen" }}</h1>

<div mat-dialog-content>
    <kiene-entsorger-details (saved)="dialogRef.close($event)" [dialog]="true" [entsorger]="entsorger">
        <ng-container additional-actions>
            <button (click)="dialogRef.close()" mat-button>Abbrechen</button>
        </ng-container>
    </kiene-entsorger-details>
</div>
